import React, { useState } from 'react';
import { Button, TreeSelect } from 'antd';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const { SHOW_PARENT } = TreeSelect;
dayjs.extend(utc);
dayjs.extend(timezone);

const TreeSelectComponent = (props) => {
    const mapTreeData = (tree) => {
        return tree.map(node => ({
            ...node,
            title: node.Name,
            key: node.Code,
            value: node.Code, // Use Code as the value
            children: node.children ? mapTreeData(node.children) : undefined,
        }));
    };
    const mappedTreeData = mapTreeData(props.deviceTreeData || []);


    const [selectedTreeData, setSelectedTreeData] = useState([]);

    // Helper: Deep clone tree (to avoid mutating props)
    const cloneTree = (tree) => {
        return tree.map(node => ({
            ...node,
            title: node.Name,
            value: node.Code,
            key: node.Code,
            children: node.children ? cloneTree(node.children) : undefined,
        }));
    };

    const getReportData = async () => {
        const { deviceTreeData } = props;

        let newObj = [];
        let removeObj = [];

        // Find children for selected parent nodes
        selectedTreeData.forEach((selectedKey) => {
            deviceTreeData.forEach((device) => {
                if (device.Code === selectedKey && device.children) {
                    removeObj.push(selectedKey);
                    device.children.forEach((child) => {
                        newObj.push(child.Code);
                    });
                }
            });
        });

        // Remove parent keys if children are selected
        let selectedTreeData1 = selectedTreeData.filter(
            (val) => !removeObj.includes(val)
        );

        let tagsList = [...selectedTreeData1, ...newObj];

        // Clone deviceTreeData before modifying
        let columns = cloneTree(deviceTreeData).map((tree) => {
            if (tree && tree.children) {
                tree.children = tree.children
                    .map((child) => {
                        if (tagsList.includes(child.Code)) {
                            return {
                                ...child,
                                dataIndex: child.value,
                                width: 150,
                            };
                        }
                        return undefined;
                    })
                    .filter(Boolean);

                if (tree.children.length > 0) {
                    return {
                        ...tree,
                        dataIndex: tree.value,
                        width: 150,
                    };
                }
                return undefined;
            } else {
                if (tagsList.includes(tree.Code)) {
                    return {
                        ...tree,
                        dataIndex: tree.value,
                        width: 150,
                    };
                }
                return undefined;
            }
        }).filter(Boolean);

        columns.unshift({
            title: "Date",
            dataIndex: "Date",
            key: "Date",
            isUTC: true,
            fixed: "left",
            width: 120,
            render: (text, record) => {
                const formats = {
                    "daily": "YYYY-MM-DD HH:mm:ss",
                    "monthly": "YYYY-MM-DD",
                    "yearly": "MMMM"
                };

                let formattedText = text;
                if (record && formats[record.Type]) {
                    formattedText = dayjs.utc(text).tz(props.currentTimeZone).format(formats[record.Type]);
                }

                return (
                    <div>{formattedText}</div>
                );

            },
        });

        props.onTreeSelectSubmit(columns, tagsList);

    };

    const onTreeSelectChange = (newValue) => {
        setSelectedTreeData(newValue);
    };

    const treeProps = {
        treeData: mappedTreeData,
        value: selectedTreeData,
        onChange: onTreeSelectChange,
        treeCheckable: true,
        showCheckedStrategy: SHOW_PARENT,
        searchPlaceholder: "Please select",
        allowClear: true,
        style: { width: "500px" },
    };

    return (
        <div>
            <TreeSelect {...treeProps} />
            <Button type="primary" onClick={getReportData}>
                Submit
            </Button>
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        currentTimeZone: state.LayoutReducer.currentTimeZone
    };
};

export default connect(mapStateToProps)(TreeSelectComponent);